export default __webpack_public_path__ + "static/media/1154.d43d53bd.png";